import React, { SetStateAction, useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import variables from "../../../assets/styles/variables.module.scss";
import SummaryCard from "../../../Shared-ui/SharedComponents/Cards/SummaryCard";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloseIcon from "@mui/icons-material/Close";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import OldAgent from "../../../Shared-ui/Types/OldAgent";
import Template from "../../../Shared-ui/Types/Template";
import { FAQ } from "../../../Shared-ui/Types/common";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";
import Confirm from "../../../Shared-ui/Types/Confirm";
import { useDispatch } from "react-redux";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { usePapaParse } from "react-papaparse";
import { DuplicateQuestionException, FileColumnException } from "../../../Shared-ui/Exceptions/FileException";


interface MyComponentProps {
  knowledgeBase: OldAgent | Template | any;
  setknowledgeBase: React.Dispatch<SetStateAction<OldAgent | Template | any>>;
  getknowledgeBase: () => void;
  updateknowledgeBase: () => void;
}

const SourceFaq: React.FC<MyComponentProps> = (props) => {
  const FAQErrorInitial = {
    question: { error: "", value: false },
    answer: { error: "", value: false },
  }
  const FAQInitial = {
    id: 0,
    question: "",
    answer: "",
  }
  const [expanded, setExpanded] = useState<boolean>(false); // Track expanded panel
  const [isEditingId, setIsEditingId] = useState<number | null>(null); // Track editing panel
  const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({ show: false, });
  const [expandedId, setExpandedId] = useState<number | null>(null); // Details input state
  const [addNew, setAddNew] = useState<boolean>(false); // Details input state
  const [FAQ, setFaq] = useState(FAQInitial)
  const [FAQData, setFAQData] = useState<FAQ[]>([])
  const [FAQError, setFAQError] = useState(FAQErrorInitial)
  const dispatch = useDispatch()
  const { readString } = usePapaParse()

  useEffect(() => {
    setFAQData(props.knowledgeBase?.FAQ || [])
  }, [props.knowledgeBase])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setFaq((preVal) => ({ ...preVal, [name]: value }))
  }

  const handleExpansion = (panel: number) => (event: any, isExpanded: boolean) => {
    setExpandedId(panel)
    // setExpandedId((preVal) => {
    //   if (preVal === panel && !isEditingId) {
    //     return null
    //   } else {
    //     return panel
    //   }
    // });
  };

  const handleCancel = () => {
    setAddNew(false); // Reset expanded state
    setIsEditingId(null); // Exit editing mode
    setFaq(FAQInitial)
    setExpandedId(null)
  };

  const handleEditToggle = (panelId: number) => {
    setIsEditingId(isEditingId === panelId ? null : panelId);
    const FAQ = FAQData?.filter((faq: FAQ) => faq.id === panelId)[0]
    setFaq(FAQ)
    setAddNew(false)
  };

  const validateFAQ = () => {
    let ErrCount = 0
    if (!FAQ.question.trim()) {
      setFAQError(preval => ({ ...preval, question: { error: "Please enter the question", value: true } }))
      ErrCount += 1
    } else {
      setFAQError(preval => ({ ...preval, question: { error: "", value: false } }))
    }

    if (!FAQ.answer.trim()) {
      setFAQError(preval => ({ ...preval, answer: { error: "Please enter the answer", value: true } }))
      ErrCount += 1
    } else {
      setFAQError(preval => ({ ...preval, answer: { error: "", value: false } }))
    }

    if (FAQData.some((item: FAQ) => item.question === FAQ.question)) {
      dispatch(ShowError("Question already exist"))
      ErrCount += 1
    }
    return ErrCount === 0 ? true : false
  }


  const handleDelete = (panelId: number) => {
    setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
    props.setknowledgeBase((preVal: OldAgent) => {
      const existingFAQ = preVal.FAQ || []
      const updatedFAQ = existingFAQ?.filter((faq: FAQ) => faq.id !== panelId)
      preVal.FAQ = updatedFAQ
      return preVal
    })
    props.updateknowledgeBase()
  }

  const deleteConfirm = (row: number) => {
    setConfirmPopupData({
      show: true,
      setConfirmPopupData: setConfirmPopupData,
      title: "Confirm Delete",
      info: "Are you sure want to delete your data? This action cannot be undone.",
      varient: "delete",
      functionName: handleDelete,
      functionParam: row,
    });
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    const file = files && files.length > 0 ? files[0] : null
    const reader = new FileReader()
    const QALastId = FAQData[FAQData?.length - 1].id ? FAQData[FAQData?.length - 1].id : 0
    let QAArray: FAQ[] = [];
    reader.onload = function (e) {
      const text: any = e.target?.result;
      readString(text, {
        worker: true,
        skipEmptyLines: true,
        complete: (result) => {
          try {
            for (let i = 0; i < result.data.length; i++) {
              const data: any = result.data[i]
              if (data.length && data?.length != 2) {
                throw new FileColumnException("File required only two column question and answer")
              } else {
                if (FAQData.some((faq: FAQ) => faq.question === data[0])) {
                  throw new DuplicateQuestionException("Question already exist")
                } else {
                  QAArray.push({ question: data[0], answer: data[1], id: QALastId + 1 });
                }
              }
            }
            props.setknowledgeBase((preVal: OldAgent) => {
              const existingFAQ = preVal.FAQ || []
              const updatedFAQ = [...QAArray, ...existingFAQ]
              preVal.FAQ = updatedFAQ
              return preVal
            })
            props.updateknowledgeBase()

          } catch (err: any) {
            if (err instanceof TypeError) {
              dispatch(ShowError("File reading error"))
            } else {
              dispatch(ShowError(err.message))
            }

          }
        }
      })
    }
    if (file) {
      reader.readAsText(file)
    }
  }
  const handleSave = (panelId?: number) => {
    if (!validateFAQ()) return;
    if (panelId === null || panelId === undefined) {
      props.setknowledgeBase((preVal: OldAgent) => {
        const existingFAQ = preVal.FAQ || []
        FAQ.id = existingFAQ[existingFAQ?.length - 1] && existingFAQ[existingFAQ?.length - 1].id >= 0 ? existingFAQ[existingFAQ?.length - 1].id + 1 : 0
        const updatedFAQ = [FAQ, ...existingFAQ]
        preVal.FAQ = updatedFAQ
        return preVal
      })
    }
    else {
      props.setknowledgeBase((preVal: OldAgent) => {
        const existingFAQ = preVal.FAQ || []
        existingFAQ[panelId].answer = FAQ.answer
        existingFAQ[panelId].question = FAQ.question
        preVal.FAQ = existingFAQ
        return preVal
      })
    }
    // setIsEditingId(null); // Exit editing mode
    // setFaq(FAQInitial)
    // setExpandedId(null)
    handleCancel()
    props.updateknowledgeBase()
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "block",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          ml: -2,
          mr: -2,
        }}
      >
        {/* Left Content */}
        <Box
          sx={{
            width: {
              lg: "calc(100% - 300px)",
              md: "calc(100% - 300px)",
              sm: "100%",
            },
            flex: "0 0 auto",
            boxSizing: "border-box",
            minWidth: {
              lg: "calc(100% - 300px)",
              md: "calc(100% - 300px)",
              sm: "100%",
            },
            pl: 2,
            pr: 2,
            maxWidth: "100%",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" gutterBottom>
              FAQ
            </Typography>
            <Box>

              <Tooltip title="Upload file" placement="top">
                <label htmlFor="file-upload">
                  <IconButton
                    component="label"
                    color="secondary"
                    aria-label="attach file"
                    sx={{ color: variables.secondaryColor }}
                    disabled={Boolean(isEditingId)}
                  >
                    <AttachFileIcon />
                    <input
                      type="file"
                      id="file-upload"
                      onChange={handleFileChange}
                      hidden
                      accept=".csv"
                    />
                  </IconButton>
                </label>
              </Tooltip>

              <Tooltip title="Add Question" placement="top">
                <IconButton
                  color="secondary"
                  aria-label="add icon"
                  sx={{ color: variables.primaryColor }}
                  disabled={Boolean(isEditingId)}
                  onClick={() => setAddNew(true)}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          {/* Add Question Box */}
          {addNew && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
                pt: "10px",
              }}
            >
              <FormControl fullWidth variant="outlined" error={FAQError.question.value}>
                <InputLabel
                  htmlFor="question"
                  shrink
                  sx={{ background: "#fff", px: 0.5 }}
                >
                  Question
                </InputLabel>
                <TextField
                  size="small"
                  id="question"
                  name="question"
                  placeholder="Enter the question"
                  value={FAQ.question}
                  onChange={(e) => handleChange(e)}
                  error={FAQError.question.value}
                  helperText={FAQError.question.error}
                  sx={{ background: "white" }}
                />
              </FormControl>

              <FormControl fullWidth variant="outlined" error={FAQError.answer.value}>
                <InputLabel
                  htmlFor="answer"
                  shrink
                  sx={{ background: "#fff", px: 0.5 }}
                >
                  Answer
                </InputLabel>
                <TextField
                  id="answer"
                  name="answer"
                  placeholder="Enter the answer"
                  multiline
                  maxRows={4}
                  value={FAQ.answer}
                  onChange={(e) => handleChange(e)}
                  error={FAQError.answer.value}
                  helperText={FAQError.answer.error}
                  sx={{ background: "white" }}
                />
              </FormControl>

              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="outlined"
                  disableElevation
                  size="large"
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  disableElevation
                  size="large"
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={() => handleSave()}
                >
                  Save
                </Button>
              </Box>
            </Box>
          )}




          {/* Accordion */}
          <Box
            sx={{
              my: 3,
            }}
          >
            {FAQData.map((faq: FAQ, index: number) => (
              <Accordion
                key={faq.id}
                expanded={expandedId === faq.id}
                onChange={handleExpansion(faq.id)}
                disabled={(isEditingId && isEditingId !== faq.id) ? true : false}
                sx={{
                  boxShadow: "none",
                  border: `solid 1px ${variables.borderColor}`,
                  borderRadius: "6px",
                  mb: 1,
                  "&::before": { display: "none" },
                  "&.Mui-expanded": { mb: 1 },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${faq.id}-content`}
                  id={`panel${faq.id}-header`}
                >
                  {isEditingId === faq.id ? (
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      name="question"
                      value={FAQ.question}
                      onChange={handleChange}
                    />
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <Typography variant="body2" fontWeight={600}>{faq.question}</Typography>
                      <Box>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => handleEditToggle(faq.id)}
                        >
                          <ModeEditOutlinedIcon />

                        </IconButton>
                        <IconButton
                          size="small"
                          color="secondary"
                          onClick={() => deleteConfirm(faq.id)}
                        >
                          <DeleteOutlineIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  )}
                </AccordionSummary>




                {/* editing section */}

                <AccordionDetails>
                  {isEditingId === faq.id ? (
                    <Box>
                      <TextField
                        fullWidth
                        multiline
                        minRows={4}
                        variant="outlined"
                        name="answer"
                        id="answer"
                        value={FAQ.answer}
                        onChange={(e) => handleChange(e)}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{ mt: 2 }}
                          onClick={() => handleSave(index)}
                        >
                          Save
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{ mt: 2 }}
                          onClick={() => handleCancel()}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Box>
                  ) : (
                    <Typography variant="body2">{faq.answer}</Typography>
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>




        {/* Right Summary Card */}
        <Box
          sx={{
            width: { lg: "300px", md: "300px", sm: "100%" },
            minWidth: { lg: "300px", md: "300px", sm: "100%" },
            boxSizing: "border-box",
            flex: "0 0 auto",
            pl: 2,
            pr: 2,
            mt: { lg: "0", md: "0", sm: "30px" },
          }}
        >
          <SummaryCard />
        </Box>
      </Box>

      <ConfirmPopup details={confirmPopupData} />
    </Box>
  );
};

export default SourceFaq;
